module.exports = __webpack_public_path__ + "static/media/1.707cfa24.png";